export const allOtas = ["bookingdotcom", "agoda", "goibibo", "yatra", "expedia", "booklogic", "simplotel"];
export const otasExceptBooklogic = ["bookingdotcom", "agoda", "goibibo", "yatra", "expedia", "simplotel"];
